import { createRouter, createWebHistory } from 'vue-router';

import privateRoutes from '@/router/private';
import publicRoutes from '@/router/public';
// import Logger from '@/utils/logger';

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PATH),
  routes: [
    {
      path: '/:catchAll(.*)',
      // The dashboard route is in private routes:
      // @/router/private
      redirect: '/dashboard',
    },
    ...privateRoutes,
    ...publicRoutes,
  ],
});

router.beforeEach(async (to, from, next) => {
  // Logger.debug('in HUB route flow');
  return next();
});

router.afterEach(() => {
  // router.app.pageLoading = false;
});

export default router;
